import {
  CloseOutlined,
  LoadingOutlined,
  QuestionCircleFilled,
} from '@ant-design/icons';
import { Button, Form, Input, Modal, Popover } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { POST } from 'utils';
import { api } from 'utils/apiRoutes';
const { Item } = Form;
const { Password } = Input;

const PasswordTimer = ({ changeTab }: { changeTab: (tab: string) => void }) => {
  const [time, setTime] = React.useState(300);
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  const [value, setValue] = React.useState({
    password: '',
    code: '',
  });
  const { password, code } = value;
  const [confirmValue, setConfirmValue] = React.useState(' ');
  const [open, setOpen] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [form] = Form.useForm();

  async function changePassword(value: {
    code: string;
    new_password: string;
    username: string;
  }) {
    setLoading(true);
    const res = await fetch(api.reset_password, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(value),
    });
    switch (res.status) {
      case 400:
        setOpenModal(true);
        setLoading(false);
        setValue((p) => ({ ...p, code: '' }));
        break;
      default:
        setLoading(false);
        changeTab('4');
        break;
    }
  }
  React.useEffect(() => {
    const timer = setInterval(() => {
      setTime(time - 1);
    }, 1000);

    if (time === 0) {
      clearInterval(timer);
    }

    return () => {
      clearInterval(timer);
    };
  });
  return (
    <>
      <Form
        name={'login'}
        form={form}
        className="login_content_form_main is-relative"
        style={{ marginLeft: '5rem', marginTop: '1.7rem' }}
        onFinish={(v) =>
          changePassword({
            ...v,
            username: sessionStorage.getItem('username'),
          })
        }
      >
        <Item style={{ marginBottom: '0' }} name={'code'} rules={[{ max: 6 }]}>
          <Input
            className="has-text-centered"
            style={{ height: '3.5rem', fontSize: 24 }}
            onChange={(e) => setValue((p) => ({ ...p, code: e.target.value }))}
          />
        </Item>
        <div className="is-flex is-justify-content-center">
          <Button
            type="link"
            disabled={time !== 0}
            onClick={async () => {
              const res = await POST(api.send_request, {
                username: sessionStorage.getItem('username'),
              });
              if (res.status === 200) {
                setTime(300);
              }
            }}
          >
            Resend code
            {time !== 0 && (
              <span className="ml-2">
                ({minutes.toString().length === 1 && '0'}
                {minutes}:{seconds.toString().length === 1 && '0'}
                {seconds})
              </span>
            )}
          </Button>
        </div>
        <div className="is-flex mb-2 is-justify-content-space-between">
          <div style={{ width: '10em' }} />
          <Popover
            arrow={false}
            open={open}
            trigger="click"
            onOpenChange={() => setOpen((open) => !open)}
            content={
              <>
                <ul>
                  <li style={{ height: '25px' }}>
                    <span>Must be at least 8 characters in length</span>
                    <Button
                      icon={<CloseOutlined />}
                      type={'text'}
                      onClick={() => setOpen(false)}
                      className={'ml-5'}
                    />
                  </li>
                  <li>Must contain at least one lower-case letter</li>
                  <li>Must contain at least one upper-case letter</li>
                  <li>Must contain at least one number</li>
                </ul>
              </>
            }
            placement="rightTop"
          >
            <QuestionCircleFilled />
          </Popover>
        </div>
        <Item
          name={'new_password'}
          rules={[
            { required: true, message: 'Password is required' },
            {
              pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
              message: 'Ineligible password',
            },
          ]}
          id="new_password"
        >
          <Password
            id="new_password"
            placeholder={'New Password'}
            prefix={<img src={'/assets/lock.svg'} alt={'icon'} />}
            size={'large'}
            onChange={(e) =>
              setValue((p) => ({ ...p, password: e.target.value }))
            }
            style={{ background: '#EFEEF4', height: '3rem' }}
          />
        </Item>
        <Item
          rules={[
            {
              required: true,
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('new_password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    'The confirm password that you entered do not match!',
                  ),
                );
              },
            }),
          ]}
          dependencies={['new_password']}
          name={'Confirm Password'}
        >
          <Password
            id="confirm_password"
            placeholder={'Confirm Password'}
            onChange={(e) => setConfirmValue(e.target.value)}
            prefix={<img src={'/assets/lock.svg'} alt={'icon'} />}
            size={'large'}
            style={{ background: '#EFEEF4', height: '3rem' }}
          />
        </Item>

        <Item>
          <SubmitButton
            type={'submit'}
            style={{
              background:
                confirmValue !== password || code === '' || code.length !== 6
                  ? '#E4E4E4'
                  : '#0E3063',
            }}
            disabled={
              confirmValue !== password ||
              code === '' ||
              code.length !== 6 ||
              loading
            }
          >
            <span style={{ color: '#fff' }}>
              {loading ? <LoadingOutlined /> : 'Change Password'}
            </span>
          </SubmitButton>
        </Item>
      </Form>
      <Modal
        open={openModal}
        centered
        footer={null}
        onOk={() => setOpenModal(false)}
        closeIcon={null}
        title={null}
        width={' 18.75rem'}
      >
        <div style={{ height: '6.785rem' }}>
          <p style={{ color: '#000', fontSize: '1rem' }}>
            {' '}
            <img src={'/icons/action.svg'} alt={'icon'} className={'mr-2'} />
            Incorrect code
          </p>
          <div style={{ height: '3em' }} />
          <Button
            type={'primary'}
            style={{ width: '4.375rem' }}
            className={'is-pulled-right'}
            onClick={() => setOpenModal(false)}
          >
            OK
          </Button>
        </div>
      </Modal>
    </>
  );
};
const SubmitButton = styled.button`
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
`;
export default PasswordTimer;
